import styled from "styled-components";

export const ReleaseMemberName = styled.p`
  width: fit-content;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--white-secondary);
`;

export const ReleaseMemberText = styled.p``;

export const ReleaseTextList = styled.ul`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  gap: 48px;
`;
